
<div id="content" #content class="{{message === 'HAS_PARENT' ? 'container-with-parent' : 'container' }} mb-5">
    <div class="resume-wrapper">
        <div class="row">
            <div class="col-md-12">
                <p>test cover</p>
            </div>
        </div>
        </div>
        </div>